import { useTranslation } from 'react-i18next';

export const ViableConcentrationPercentage = ({
  concentration,
  viability,
}: {
  concentration: number;
  viability: number;
}) => {
  const { t } = useTranslation();

  const conz = concentration ? concentration : 0;
  const viab = viability ? viability : 0;
  const viableConcentration = (conz * viab) / 100;

  return (
    <div className="flex">
      <div className="w-60">
        <div className="text-gray-600 text-xl font-bold">
          {t('measurements.viableConcentration')}
        </div>
        <div className="font-normal">{t('measurements.details.mil')}</div>
      </div>
      <div className="text-gray-600 text-3xl font-bold">
        {viableConcentration.toFixed(2)}
      </div>
    </div>
  );
};
